<header>
    {{ title }}
</header>
<section>
    <label for="dialog-user-input">
        {{ text }}
    </label>
    <input id="dialog-user-input" [placeholder]="text" type="text" [(ngModel)]="userInput">
</section>
<footer>
    <div mat-dialog-close class="button red fill">
        <span i18n>{{ cancelLabel }}</span>
    </div>
    <div class="button green fill" [class.disabled]="!userInput" [mat-dialog-close]="userInput">
        <span i18n>{{ submitLabel }}</span>
    </div>
</footer>
